import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../../models/State"
import {FacetState} from "../../../models/FacetsState"
import {FilterPriceApiResponse} from "../../../models/Filter"
import {shouldDisplayPriceFilter} from "../../../utils/urlBuilder"

interface OwnProps {
    firstFilterList?: string[]
}

const selectFacet = (state: State) => state.search.facets
const selectPriceFilter = (state: State) => state.search.filters?.Price
const selectFirstFilterList = (_state: State, firstFilterList: string[]) => firstFilterList

const makeAllOtherFiltersSelected = createSelector(
    [selectFacet, selectPriceFilter, selectFirstFilterList],
    (facets, priceFilter, firstFilterList) => {
        const facetsAll: FacetState[] = Object.keys(facets)
            .filter(facetName => !firstFilterList.includes(facetName.split(":")[0]))
            .map(facetName => facets[facetName])

        const numberOfOtherFiltersSelected = facetsAll.filter(facet => facet.s === true).length

        const anyOptionSelected =
            shouldDisplayPriceFilter(priceFilter as FilterPriceApiResponse) || numberOfOtherFiltersSelected > 0

        return {
            allOtherFiltersSelected: anyOptionSelected,
        }
    },
)

export const mapStateToProps = (state: State, ownProps: OwnProps) => {
    const {firstFilterList = []} = ownProps
    const {template, text} = state

    return {
        text,
        templating: template,
        ...makeAllOtherFiltersSelected(state, firstFilterList),
    }
}

export default connect(mapStateToProps)
